import { Injectable } from '@angular/core';
import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../../shared/service/rest.service';
import { Group } from '../model/group';

@Injectable()
export class GroupService extends RestService {

  fetchGroups(): Observable<Group[]> {
    return this.postAndExtract<Group>(Group, 'api/admin/group/fetch').pipe(
      map(groups => sortBy(groups, group => group.name))
    );
  }

  addGroup(group: Group): Observable<Group> {
    return this.postAndExtractSingle<Group>(Group, 'api/admin/service/group/gwt/add', { data: this.convertToServerPayload(group) });
  }

  /** Zakłada grupę na bazie istniejącej: dane bierze z formularza, a ustawienia kopiuje z grupy źródłowej. */
  copyGroup(sourceGroupId: number, group: Group): Observable<Group> {
    return this.postAndExtractSingle<Group>(
      Group, `api/admin/service/group/${sourceGroupId}/gwt/copy`, { data: this.convertToServerPayload(group) }
    );
  }

  modifyGroup(group: Group): Observable<Group> {
    return this.putAndExtractSingle<Group>(Group, 'api/admin/service/group/gwt/update', { data: this.convertToServerPayload(group) });
  }

  removeGroup(group: Group): Observable<Group> {
    return this.postAndExtractSingle<Group>(Group, 'api/admin/service/group/remove', { data: this.convertToServerPayload(group) });
  }

  private convertToServerPayload(group: Group): any {
    return {
      groupId: group.groupId,
      name: group.name,
      priority: group.priority,
      users: group.users?.map(user => user.id),
      vehicles: group.vehicles?.map(vehicle => vehicle.id),
      fields: group.fields?.map(field => field.fieldId),
      carrier_id: group.carrier?.id,
      depot_id: group.depot?.depotId
    };
  }

}
